import { render } from "./WebcamBox.vue?vue&type=template&id=10319176"
import script from "./WebcamBox.vue?vue&type=script&lang=ts"
export * from "./WebcamBox.vue?vue&type=script&lang=ts"

import "./WebcamBox.vue?vue&type=style&index=0&id=10319176&lang=scss"
script.render = render

export default script